export const Eventos = {
    Aviso: 1,
    Notificaciones: 2,
    CierreSesion: 3,
    VerificarSubscripcion: 5,
    ComprobacionGeneral: 7
};
